import React from 'react';

interface Achievement {
  id: string;
  award: string;
  category: string;
  recipient: string;
  field: string;
}

const achievements: Achievement[] = [
  {
    id: '1',
    award: 'Overall Best Final 2 Student',
    category: 'Academic Excellence',
    recipient: 'Milicent Naa',
    field: 'Final 2'
  },
  {
    id: '2',
    award: 'Overall Best Final 2 Student',
    category: 'Academic Excellence',
    recipient: 'David Awudza',
    field: 'Strategic Tax Planning'
  },
  {
    id: '3',
    award: 'Overall Best Final 2 Student',
    category: 'Academic Excellence',
    recipient: 'Musah Crispinus',
    field: 'Advanced Taxation Practice'
  },
  {
    id: '4',
    award: 'Overall Best Final 2 Student',
    category: 'Academic Excellence',
    recipient: 'Owureku Nsiah',
    field: 'Final 2'
  },
  {
    id: '5',
    award: 'Specialized Award',
    category: 'Field Excellence',
    recipient: 'Felicia Omotoyo',
    field: 'Public Sector Economic and Finance'
  },
  {
    id: '6',
    award: 'Overall Best Final 1 Student',
    category: 'Academic Excellence',
    recipient: 'Michael Ansah',
    field: 'Oil and Gas Taxation'
  },
  {
    id: '7',
    award: 'Specialized Award',
    category: 'Field Excellence',
    recipient: 'Emmanuel Ampadu',
    field: 'Accounting and Finance'
  },
  {
    id: '8',
    award: 'Specialized Award',
    category: 'Field Excellence',
    recipient: 'Beryl Bonney',
    field: 'International Taxation'
  }
];

const HallOfExcellence: React.FC = () => {
  return (
    <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-200">
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-amber-100 rounded-full mb-6">
          <span className="text-4xl">🏆</span>
        </div>
        <h2 className="text-4xl font-bold text-gray-800 mb-3">Hall of Excellence</h2>
        <div className="w-24 h-1 bg-amber-500 mx-auto mb-3"></div>
        <p className="text-xl text-gray-600 font-medium">2020-Present</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {achievements.map((achievement) => (
          <div key={achievement.id} className="bg-gradient-to-b from-amber-50 to-white rounded-lg p-6 shadow-md hover:shadow-lg transition-shadow duration-300 border border-amber-200">
            <div className="text-center">
              <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">⭐</span>
              </div>
              <h3 className="text-lg font-bold text-amber-700 mb-2">{achievement.award}</h3>
              <p className="text-sm text-amber-600 font-medium mb-3 bg-amber-100 px-3 py-1 rounded-full inline-block">{achievement.category}</p>
              <h4 className="text-xl font-bold text-gray-800 mb-2">{achievement.recipient}</h4>
              <p className="text-gray-600 text-sm">{achievement.field}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HallOfExcellence;
